import React, { forwardRef } from 'react';
import type { TypographyProps } from '@mui/material';
import { Typography as TypographyMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_FONT_WEIGHT, CUSTOM_ATTRIBUTE_TEXT_TRANSFORM } from './Typography.api';

type Props = {
  fontWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
};

const Typography = forwardRef<HTMLSpanElement, TypographyProps & Props>((props, ref) => (
  <TypographyMUI
    {...omitUndefinedProps({
      ...props,
      fontWeight: undefined,
      textTransform: undefined,
      [CUSTOM_ATTRIBUTE_FONT_WEIGHT]: props.fontWeight,
      [CUSTOM_ATTRIBUTE_TEXT_TRANSFORM]: props.textTransform,
    })}
    ref={ref}
  />
));

Typography.displayName = 'Typography';

export default Typography;
